var map = {
	"./Clientes.svg": "902a",
	"./EmptyState.svg": "4d84",
	"./Plantillas.svg": "f381",
	"./applications/asana.svg": "e833",
	"./applications/bitbucket.svg": "508c",
	"./applications/clickup.svg": "c69c",
	"./applications/github.svg": "ac47",
	"./applications/gitlab.svg": "375e",
	"./applications/jira.svg": "9219",
	"./applications/slack.svg": "7468",
	"./logo.svg": "1ae4",
	"./tutorial/step1.1.svg": "d4f4",
	"./tutorial/step1.svg": "76e2",
	"./tutorial/step2.1.svg": "fc64",
	"./tutorial/step2.2.svg": "75ce",
	"./tutorial/step3.svg": "f2e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";